import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const DeleteModal = ({
  isOpen,
  toggle,
  data,
  onConfirm,
  title = "Delete Item",
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>

      <ModalBody>
        Are you sure you want to delete{" "}
        <b>{data?.name||data?.clinic_name || "this item"}</b>?
      </ModalBody>

      <ModalFooter>
        <Button color="light" onClick={toggle}>
          Cancel
        </Button>

        <Button
          color="danger"
          onClick={() => {
            onConfirm(data);
            toggle();
          }}
        >
          Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteModal;

